import {post} from '../utils/request'

export default {
    getAll: function (query, paginate) {
        return post("/admin/useinfo/list", {...query, ...paginate});
    },
}
